export const data = {
    'projectCards': [
        {
            'subtitle': 'solo project',
            'title': 'Git Time Travel Game Proof of Concept',
            'tags': ['Procreate', 'C#', 'Unity'],
            'description': 'Learning Git is a rite of passage for emerging developers. This game\'s proof of concept aims to teach developers how to use Git with an analogy to branching timelines.',
            'projectURL': 'https://github.com/nghia-t-nguyen/git-time-travel-game-poc',
            'learnMoreURL': '/git-time-travel',
        },
        {
            'subtitle': 'hobby',
            'title': 'Native Plant House Garden',
            'tags': ['Garden Design', 'Interactive', 'Ongoing'],
            'description': 'I picked up native gardening for environmental efforts. Explore how I used environmental factors to inform my design decisions.',
            'projectURL': '',
            'learnMoreURL': '/native-gardening',
        },
        {
            'subtitle': 'internship',
            'title': 'Twilio Projects and Articles',
            'tags': ['Python', 'JS', 'API', 'Technical Writing'],
            'description': 'At Twilio, I worked as a developer educator to help empower developers and teach them how to use Twilio\'s products.',
            'projectURL': 'https://www.twilio.com/en-us/blog/authors/author.ngnguyen',
            'learnMoreURL': '',
        },
        {
            'subtitle': 'research',
            'title': 'Lattice Vibrations via Deep GNNs',
            'tags': ['Python', 'TensorFlow', 'Pandas', 'MatPlotLib'],
            'description': 'This study introduces a deep graph neural network algorithm to predict crystal vibrational frequencies from crystal structures. ',
            'projectURL': 'https://pubs.acs.org/doi/10.1021/acsomega.2c02765',
            'learnMoreURL': '',
        },
        {
            'subtitle': 'capstone',
            'title': 'Pweek: Pohnpeian Language App',
            'tags': ['Flutter', 'Dart', 'Firebase', 'Cloud Firestore'],
            'description': 'Pohnpeian is a language with less than 30,000 native speakers. With Pweek, a mobile Android app, users can be a part of keeping this language alive.',
            'projectURL': 'https://github.com/SCCapstone/Downpour',
            'learnMoreURL': '',
        },
        {
            'subtitle': 'artwork',
            'title': 'Rooted: Photography Final Portfolio',
            'tags': ['Film Photography'],
            'description': 'As an undergrad portfolio, "Rooted" is a lyrical documentary that aims to convey the atmosphere of my dysfunctional family\'s growth, disrepair, and repair.',
            'projectURL': '',
            'learnMoreURL': '/photo-portfolio',
        },
        {
            'subtitle': 'portfolio',
            'title': 'Personal Website 1.0',
            'tags': ['ReactJS', 'HTML', 'CSS', 'JS'],
            'description': 'The second personal website that I made after I learned ReactJS. This portfolio is VHS themed.',
            'projectURL': 'https://nghia-t-nguyen.netlify.app/',
            'learnMoreURL': '',
        },
        // {
        //     'subtitle': 'portfolio',
        //     'title': 'Personal Website 0.0',
        //     'tags': ['HTML', 'CSS', 'JS'],
        //     'description': 'My very first personal website that draws upon risograph printing for inspiration.',
        //     'projectURL': 'https://nghia-t-nguyen.github.io/',
        //     'learnMoreURL': '',
        // },
        {
            'subtitle': 'artwork',
            'title': 'Misc Art Gallery',
            'tags': ['Illustration', 'Photography', 'Crafts'],
            'description': 'An art gallery of random things I made along the way. I am a developer by trade and an artist by soul.',
            'projectURL': '',
            'learnMoreURL': '/misc-art-gallery',
        },

    ]
}